import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getMoviesByCategory } from "@/utils/movie";

const hotTags = ["年代", "爱情", "悬疑", "都市", "复仇", "治愈", "孤独", "命运"];

export default function CategorySidebar() {
  return (
    <div className="space-y-5">
      <nav className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
          <i className="ri-list-check-2 text-base text-primary-600" aria-hidden="true" />
          内容分类
        </h3>
        <ul className="mt-3 space-y-1">
          {categories.map((cat) => (
            <li key={cat.id}>
              <Link
                to={`/category/${cat.id}`}
                className="flex items-center gap-3 rounded-md px-2.5 py-2 text-sm text-foreground-700 transition-colors duration-200 hover:bg-primary-50 hover:text-primary-700"
              >
                <i className={`${cat.icon} text-base text-primary-500`} aria-hidden="true" />
                <span className="font-medium">{cat.name}</span>
                <span className="ml-auto text-xs text-foreground-400">
                  {getMoviesByCategory(cat.id).length}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <div className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
          <i className="ri-price-tag-3-line text-base text-accent-600" aria-hidden="true" />
          热门标签
        </h3>
        <div className="mt-3 flex flex-wrap gap-2">
          {hotTags.map((tag) => (
            <Link
              key={tag}
              to={`/search?q=${encodeURIComponent(tag)}`}
              className="rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-900 transition-colors duration-200 hover:bg-accent-200"
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-primary-200 bg-primary-50 p-4">
        <h3 className="flex items-center gap-2 text-sm font-bold text-primary-800">
          <i className="ri-information-line text-base" aria-hidden="true" />
          使用提示
        </h3>
        <p className="mt-2 text-xs leading-relaxed text-primary-900/80">
          可按分类、年份、评分与关键词筛选查找作品。点击任意卡片即可进入详情页查看完整剧情与演职员信息。
        </p>
        <p className="mt-2 text-xs leading-relaxed text-primary-900/70">
          本站为演示站点，片名与人物均为示例数据，不提供在线播放与下载。
        </p>
      </div>
    </div>
  );
}